import { createDateSafe } from '@/utils/dateUtils';
import { differenceInCalendarDays } from 'date-fns';
import type { SegmentReviewState } from '../../utils/vacationSegments';

export const CARD_LABELS = {
    approve: 'Aprovar',
    reject: 'Reprovar',
    details: 'Ver detalhes',
    requestedAt: 'Solicitada em',
    deadline: 'Prazo para aprovar',
    conflictsTitle: 'Conflito com alocação',
    sellRequestNotice: (days: number, totalDays: number) =>
        `Abono pecuniário de ${days} dias — gozo reduzido a ${totalDays} dias em período único. Quem decide é o DP.`,
} as const;

export type SegmentBadgeSource = 'dp' | 'client';

export interface SegmentReviewBadge {
    label: string;
    className: string;
}

export const SEGMENT_REVIEW_BADGES: Record<SegmentBadgeSource, Record<SegmentReviewState, SegmentReviewBadge | null>> = {
    dp: {
        pending: null,
        approved: { label: 'Validado pelo DP', className: 'bg-emerald-100 text-emerald-700' },
        rejected: { label: 'Reprovado pelo DP', className: 'bg-red-100 text-red-700' },
        corrected: { label: 'Período corrigido', className: 'bg-amber-100 text-amber-800' },
    },
    client: {
        pending: null,
        approved: { label: 'Validado pelo cliente', className: 'bg-emerald-100 text-emerald-700' },
        rejected: { label: 'Reprovado pelo cliente', className: 'bg-red-100 text-red-700' },
        corrected: { label: 'Período corrigido', className: 'bg-amber-100 text-amber-800' },
    },
};

export interface DeadlineTone {
    className: string;
    hint: string | null;
}

export function getDeadlineTone(deadline?: string | null, today: Date = new Date()): DeadlineTone {
    const neutral: DeadlineTone = { className: 'text-raro-gray-600', hint: null };
    const parsed = createDateSafe(deadline ?? undefined);
    if (!parsed) return neutral;

    const days = differenceInCalendarDays(parsed, today);

    if (days < 0) {
        return { className: 'text-red-700 font-semibold', hint: 'vencido' };
    }
    if (days <= 7) {
        return { className: 'text-red-700 font-semibold', hint: `vence em ${days} dias` };
    }
    if (days <= 15) {
        return { className: 'text-amber-700 font-semibold', hint: `vence em ${days} dias` };
    }
    return neutral;
}
